import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Spin, Alert, Breadcrumb, Typography } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import { cmsAPI } from '../services/api';
import NavBar from '../components/NavBar';
import PageHero from '../components/PageHero';
import PageFooter from '../components/PageFooter';
import { markdownToHtml } from '../utils/markdown';
import '../styles/global.css';

const { Title } = Typography;

const ContentPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const [page, setPage] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!slug) {
      setError('页面不存在');
      setLoading(false);
      return;
    }

    loadPage();
  }, [slug]);

  const loadPage = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await cmsAPI.getPage(slug!);
      setPage(data);
    } catch (err: any) {
      if (err.response?.status === 404) {
        setError('页面不存在');
      } else {
        setError('加载失败，请稍后重试');
      }
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <>
        <NavBar />
        <PageHero />
        <div style={{ textAlign: 'center', padding: '100px 20px' }}>
          <Spin size="large" />
        </div>
        <PageFooter />
      </>
    );
  }

  if (error || !page) {
    return (
      <>
        <NavBar />
        <PageHero />
        <div style={{ maxWidth: 1200, margin: '40px auto', padding: '0 24px', minHeight: '40vh' }}>
          <Alert
            message="错误"
            description={error || '页面不存在'}
            type="error"
            showIcon
            action={
              <a onClick={() => navigate('/')}>返回首页</a>
            }
          />
        </div>
        <PageFooter />
      </>
    );
  }

  return (
    <>
      <NavBar />
      <PageHero />
      <div className="content-page-container">
        <div className="content-page-header">
          <Breadcrumb>
            <Breadcrumb.Item href="/">
              <HomeOutlined />
            </Breadcrumb.Item>
            <Breadcrumb.Item>{page.section?.name}</Breadcrumb.Item>
            <Breadcrumb.Item>{page.title}</Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <div className="content-page-body">
          <Title level={1}>{page.title}</Title>
          <div
            className="content-page-content"
            dangerouslySetInnerHTML={{ __html: markdownToHtml(page.content || '') }}
          />
        </div>
      </div>
      <PageFooter />
    </>
  );
};

export default ContentPage;
